import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { UrlBuilder } from '@core/model/url-builder';
import { ListPurchaseCommissionRequestDto } from '@domain/purchase-commission/dtos/list-purchase-commission.request.dto';
import { PurchaseCommissionResponseDto } from '@domain/purchase-commission/dtos/purchase-commission.response.dto';

@Injectable({
  providedIn: 'root',
})
export class PurchaseCommissionService extends UrlBuilder {
  constructor(private http: HttpClient) {
    super('reconciliation/commission');
  }

  list(request: ListPurchaseCommissionRequestDto) {
    const queryUrl = `${this.getApiUrl()}/list`;
    return this.http.get<
      ApiResponse<PageableResponse<PurchaseCommissionResponseDto>>
    >(queryUrl, { params: { ...request } });
  }

  show(request: RefId) {
    const { refId } = request;
    const queryUrl = `${this.getApiUrl()}/show/${refId}`;
    return this.http.get<ApiResponse<PurchaseCommissionResponseDto>>(
      queryUrl,
      {},
    );
  }
}
